import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ModalHapus: false,

    rwskp: {}
  },

  mutations: {
    toggleModal(state, value) {
      state.ModalHapus = value
    },
    
    hapusModal(state, value) {
      state.rwskp = value
    },
  }
})